import { render, staticRenderFns } from "./EditProduct copy.vue?vue&type=template&id=eb3e9ab8&scoped=true&"
import script from "./EditProduct copy.vue?vue&type=script&lang=js&"
export * from "./EditProduct copy.vue?vue&type=script&lang=js&"
import style0 from "./EditProduct copy.vue?vue&type=style&index=0&id=eb3e9ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3e9ab8",
  null
  
)

component.options.__file = "EditProduct copy.vue"
export default component.exports